export const BADGE_TYPES = {
  hintPodcast: "hintPodcast",
  hintRoute: "hintRoute",
  days: "days",
  route: "route",
  subscriptions: "subscriptions",
  records: "records",
  podcast: "podcast",
  destinationTag: "destinationTag",
};


export const BADGE_TYPE_CONFIG = {
  [BADGE_TYPES.hintPodcast]: {
    label:   "Pista - Podcast",
    isBadge: false,
    isHint: true,
    backendType: null,
    fields: [
      {
        name: "podcastId",
        label: "Podcast vinculado",
        type: "select",
        dataKey: "podcasts",
        optionLabel: "title",
        isObject: true,
        required: true,
        errorMsg: "El podcast vinculado es obligatorio para una pista de podcast",
      },
    ],
  },

  [BADGE_TYPES.hintRoute]: {
    label: "Pista - Ruta",
    isBadge: false,
    isHint: true,
    backendType: null,
    fields: [
      {
        name: "routeId",
        label: "Ruta vinculada",
        type: "select",
        dataKey: "routes",
        optionLabel: "name",
        isObject: true,
        required: true,
        errorMsg: "La ruta vinculada es obligatoria para una pista de ruta",
      },
    ],
  },

  [BADGE_TYPES.days]: {
    label: "Insignia - Por días registrado",
    isBadge: true,
    isHint: false,
    backendType: "NUM_DAYS",
    fields: [
      {
        name: "numDays",
        label: "Nº de días desde que se registró para conseguirla",
        type: "number",
        isObject: false,
        required: true,
        errorMsg: "El número de días es obligatorio",
      },
    ],
  },

  [BADGE_TYPES.route]: {
    label:   "Insignia - Por ruta completada",
    isBadge: true,
    isHint:  false,
    backendType: "ROUTE",
    fields: [
      {
        name: "routeId",
        label: "Ruta a completar",
        type:  "select",
        dataKey: "routes",
        optionLabel: "name",
        isObject: true,
        required: true,
        errorMsg: "La ruta vinculada es obligatoria para este tipo de insignia",
      },
    ],
  },

  [BADGE_TYPES.subscriptions]: {
    label: "Insignia - Por suscripciones",
    isBadge: true,
    isHint: false,
    backendType: "NUM_SUBSCRIPTIONS",
    fields: [
      {
        name: "numSubscriptions",
        label: "Nº de suscripciones para conseguirla",
        type: "number",
        isObject: false,
        required: true,
        errorMsg: "El número de suscripciones es obligatorio",
      },
    ],
  },

  [BADGE_TYPES.records]: {
    label: "Insignia - Por grabaciones",
    isBadge: true,
    isHint: false,
    backendType: "NUM_RECORDS",
    fields: [
      {
        name: "numRecords",
        label:"Nº de grabaciones para conseguirla",
        type: "number",
        isObject: false,
        required: true,
        errorMsg: "El número de grabaciones es obligatorio",
      },
    ],
  },

  [BADGE_TYPES.podcast]: {
    label:   "Insignia - Por reproducción de podcast",
    isBadge: true,
    isHint:  false,
    backendType: "PODCAST",
    fields: [
      {
        name: "podcastId",
        label: "Podcast a reproducir",
        type: "select",
        dataKey: "podcasts",
        optionLabel: "title",
        isObject: true,
        required: true,
        errorMsg: "El podcast vinculado es obligatorio para este tipo de insignia",
      },
    ],
  },

  [BADGE_TYPES.destinationTag]: {
    label:   "Insignia - Por Tag Destino visitada",
    isBadge: true,
    isHint:  false,
    backendType: "DESTINATION_TAG",
    fields: [
      {
        name: "destinationTagId",
        label: "Tag Destino a visitar",
        type: "select",
        dataKey: "destinationTags",
        optionLabel: "name",
        isObject: true,
        required: true,
        errorMsg: "El Tag Destino es obligatorio",
      },
    ],
  },
};

export const ALL_TYPE_FIELDS = ["numDays", "numRecords", "numSubscriptions", "routeId", "podcastId", "destinationTagId"];
